/**
 * Rupees with the sign where a reader sees it: "−₹1,234", never "₹-1,234".
 *
 * The minus is U+2212, the typographic minus, so it lines up with the digits
 * and is not mistaken for a dash or a hyphenated range. A value that rounds to
 * zero at the chosen precision prints without a sign — "−₹0.00" says there was
 * a loss when there was not.
 */
export function formatSignedINR(n, { decimals = 0 } = {}) {
  const v = Number(n);
  if (!Number.isFinite(v)) return '₹0';
  const abs = Math.abs(v);
  const body = abs.toLocaleString('en-IN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const roundsToZero = Number(abs.toFixed(decimals)) === 0;
  return v < 0 && !roundsToZero ? `−₹${body}` : `₹${body}`;
}

export default formatSignedINR;
